import { styled } from '@mui/material/styles';
import { VpButton, VpHoverInfo } from '../../vp-ui';

const svgStyles = {
  height: '16px',
  width: '16px',
  padding: '0px'
};

export const StyledVpHover = styled(VpHoverInfo)(({ theme }) => ({
  color: theme.palette.vpColors.greyDark,
  ...svgStyles,
  svg: {
    color: theme.palette.vpColors.greyDark,
    ...svgStyles
  }
}));

export const StyleVpButtonSubmitResponse = styled(VpButton)({
  marginTop: '24px',
  width: '200px'
});



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/styles.js